<template>
    <PageWrapper class="login-page bg-bottom" image="/images/design/stadium_login.jpg">
        <div class="login-form-wrapper grid grid-cols-2 mx-auto max-w-4xl">
            <!-- Form -->
            <div class="form-col col-span-2 md:col-span-1 p-10 mt-8 relative rounded-lg md:rounded-l-lg md:rounded-r-none border-accent border-b-4 flex items-center">
                <div>
                    <h1 class="text-white">Log In</h1>
                    <div class="text-accent mt-2 mb-6 text-lg">Welcome back!</div>

                    <AccentMark width="100%" class="bg-gray-alt2"/>

                    <form v-on:submit.prevent="login">
                        <TextInput 
                            class="alt" 
                            label="Email" 
                            placeholder="Email" 
                            type="email" 
                            :settings="{labels:'hidden'}" 
                            v-model="email" 
                            :errors="errors.email"/>
                        <TextInput 
                            class="alt" 
                            id="password-check"
                            label="Password" 
                            placeholder="Password" 
                            type="password" 
                            :settings="{labels:'hidden'}" 
                            v-model="password" 
                            :errors="errors.password"/>
                        <div class="" @click="password_hide_show">
                            <i class="fas fa-eye-slash password-hide-show"></i>
                        </div>
                        <button type="submit">
                            Sign In
                            <i class="fas fa-chevron-right"></i>
                        </button>
                        <router-link :to="{name: 'forgot-password'}" class="text-gray-alt1 px-4">Forgot Password?</router-link>
                    </form>
                </div>
            </div>

            <!-- Sports Player -->
            <div class="col-span-1 relative hidden md:flex">
                <img class="player-image" style="position:relative;left:-44px;" src="/images/design/basketball-login.png"/>
            </div>
        </div>
    </PageWrapper>
</template>
<script>
export default {
    name:"Login",
    data() {
        return {
            email:'',
            password:'',
            errors:[]
        }
    },
    methods: {
        login() {
            axios.get('/sanctum/csrf-cookie').then(response => {
                var payload = {
                    email:this.email,
                    password:this.password
                }

                let self = this;
                axios.post("login", payload).then(res => {
                    self.$store.commit("login");
                    self.$router.push({name:'profile'});
                }).catch(error => {
                    self.$noty.error("Oops, something went wrong.");
                    self.errors = error.response.data.errors;
                });
            });
        },
        password_hide_show() {
            
            const password = document.querySelector("#password-check");
            const password_eye = document.querySelector(".password-hide-show");
            const type = password.getAttribute("type") === "password" ? "text" : "password";
            password.setAttribute("type", type);

            if(type == 'text') {
                password_eye.setAttribute("class","svg-inline--fa fa-w-18 fa-eye password-hide-show");
            }
            else {
                password_eye.setAttribute("class","svg-inline--fa fa-w-18 fa-eye-slash password-hide-show");
            }
        }
    }
}
</script>
<style>
.login-form {
    min-height: 30em;
}
.form-col {
    background-color: rgba(0,0,0, .55);  
    backdrop-filter: blur(9px);
}
.password-hide-show {
    position: relative;
    float: right;
    top: -33px;
    right: 8px;
    color: #888;
}
</style>